import { de } from "./de";
import { en } from "./en";

export const locales = {
  de,
  en,
};

export { numberFormats } from "./numberFormats";
